@if (show) {
  <span class="text-light-grey d-flex align-items-center gap-1">
    Téléchargement en cours
    @if (privPercent > 0) {
      <span> {{ privPercent }}% </span>
    }
    @if (privPercent > 0) {
      <svg class="round" [style]="{'stroke-dasharray': roundDraw}" viewbox="0 0 100 100"
        [attr.width]="(radius + 2) * 2" [attr.height]="(radius + 2) * 2">
        <circle [attr.cx]="radius + 2" [attr.cy]="radius + 2" [attr.r]="radius"/>
      </svg>
    }
  </span>
}

